import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface SnapPixelScriptProps {
  pixelID?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function snap(ctx: SnapPixelScriptProps) {
  /*eslint-disable */
  // prettier-ignore

  if (ctx.pixelID) {
    // @ts-ignore
    (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function() {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)}; a.queue=[];var s='script';r=t.createElement(s);r.async=!0; r.src=n;var u=t.getElementsByTagName(s)[0]; u.parentNode.insertBefore(r,u);})(window,document, 'https://sc-static.net/scevent.min.js');
    window.snapPixelID = ctx.pixelID;
    window.snaptr && window.snaptr('init', ctx.pixelID, {});
    window.snaptr && window.snaptr('track', 'PAGE_VIEW');
  }
}

export const SnapPixelScript = (props: SnapPixelScriptProps): JSX.Element => {
  const pixelID = props.pixelID || process.env.NEXT_PUBLIC_SNAP_PIXEL_ID;
  return <Head>{pixelID && makeScript(snap, { pixelID })}</Head>;
};

export default SnapPixelScript;
